/** @format */

import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { getNewsLink } from 'src/utils/helper';
import { Rating } from '../Rating';
import { useDispatch } from 'src/store';
import { setNewsTitle } from 'src/slices/news';

export const NewsItem = ({ item }) => {
  const { title, date, content, rating, link, linkTarget } = item;
  const dispatch = useDispatch();
  const handleClick = event => {
    dispatch(setNewsTitle(title || ''));

    if (link) {
      event.preventDefault();
      const target = linkTarget === '_blank' ? '_blank' : '_self';

      if (target === '_blank') {
        window.open(link, '_blank', 'noopener,noreferrer');
        return;
      }

      window.location.assign(link);
    }
  };
  return (
    <Link to={getNewsLink(item)} className="archive--list-item" onClick={handleClick}>
      <Grid className="archive--list-item-top">
        <Grid className="archive--list-item-date-title">
          <Grid className="archive--list-item-title">{title}</Grid>
          {date && (
            <Grid className="archive--list-item-date">
              {format(new Date(date * 1000), 'dd.MM.yyyy') || '00.00.0000'}
            </Grid>
          )}
        </Grid>
        {!link && rating && rating !== 0 ? <Rating rating={rating} /> : null}
      </Grid>
      <Grid className="archive--list-item-text">{content}</Grid>
    </Link>
  );
};

const skeletonStyle = { backgroundColor: 'rgba(0, 0, 0, 0.1)' };

export const NewsItemSkeleton = () => {
  return (
    <Grid className="archive--list-item archive--list-item--skeleton">
      <Grid className="archive--list-item-top">
        <Grid className="archive--list-item-date-title">
          <Grid className="archive--list-item-title">
            <Skeleton variant="text" width={200} height={28} style={skeletonStyle} />
          </Grid>
          <Grid className="archive--list-item-date">
            <Skeleton variant="text" width={80} height={20} style={skeletonStyle} />
          </Grid>
        </Grid>
        <Grid>
          <Skeleton variant="text" width={150} height={28} style={skeletonStyle} />
        </Grid>
      </Grid>
      <Grid className="archive--list-item-text">
        <Skeleton variant="text" width="100%" style={skeletonStyle} />
        <Skeleton variant="text" width="75%" style={skeletonStyle} />
      </Grid>
    </Grid>
  );
};

export const NewsListSkeleton = ({ count = 5 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <NewsItemSkeleton key={index} />
      ))}
    </>
  );
};

export const NewsDetailSkeleton = () => {
  return (
    <Grid className="news-detail-skeleton">
      <Grid className="news-detail-skeleton__header">
        <Grid className="archive-page-title-box">
          <Skeleton variant="text" width="70%" height={40} style={skeletonStyle} />
        </Grid>
        <Grid className="archive-page-rating" style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 16 }}>
          <Skeleton variant="rect" width={120} height={24} style={skeletonStyle} />
          <Skeleton variant="text" width={100} height={20} style={skeletonStyle} />
        </Grid>
      </Grid>
      <Grid className="news-detail-skeleton__content" style={{ marginTop: 32 }}>
        <Grid className="news-detail-skeleton__content" style={{ marginTop: 32 }}>
          <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
          <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
          <Skeleton variant="text" width="95%" height={20} style={skeletonStyle} />
          <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
          <Skeleton variant="text" width="80%" height={20} style={skeletonStyle} />
        </Grid>
        <Grid className="news-detail-skeleton__content" style={{ marginTop: 32 }}>
          <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
          <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
          <Skeleton variant="text" width="90%" height={20} style={skeletonStyle} />
          <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
          <Skeleton variant="text" width="70%" height={20} style={skeletonStyle} />
        </Grid>
      </Grid>
    </Grid>
  );
};
